import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'relative [--slide-size:auto] [--slide-spacing:0]',
    viewport: 'overflow-hidden',
    container: 'ml-[calc(var(--slide-spacing)*-1)] flex justify-items-start',
    arrow: 'border-0',
    slide:
      'flex w-[var(--slide-size,auto)] shrink-0 grow-0 pl-[var(--slide-spacing)]',
    dots: 'flex gap-2',
    dot: 'h-1.5 w-1.5 cursor-pointer rounded-full transition-all duration-300'
  },
  variants: {
    active: {
      true: {
        dot: 'bg-blue-dark'
      },
      false: {
        dot: 'bg-secondary-dark'
      }
    },
    disabled: {
      true: {
        arrow: 'pointer-events-none opacity-40'
      },
      false: {
        arrow: 'opacity-100'
      }
    }
  }
});
